import { transport } from 'config/transport';

export function callApiGetThuCongDoanVung(congdoanvungId, month, year, isInternal = false) {
    return transport.get(`/congdoanvung/${congdoanvungId}/thuchi/thucongdoanvung`, { params: { month, year, isInternal } });
}
